import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { useTranslationApp } from "../../../../lib/i18next";
import { PRIMARY_COLOR_TEXT } from "../../../../utils/colors";
import { logoPlatform } from "../../../../utils/string";

const CompetitorPlatformLabel = ({ platform }) => {
  const { t } = useTranslationApp();
  const logoSrc = logoPlatform(platform);

  if (!platform || !logoSrc) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        minWidth: 0,
      }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt={t(platform)}
        sx={{
          width: 16,
          height: 16,
          objectFit: "contain",
          flexShrink: 0,
        }}
      />
      <Typography
        variant="caption"
        sx={{
          color: PRIMARY_COLOR_TEXT,
          fontSize: "0.75rem",
          fontWeight: 600,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          mt: 0.25,
        }}
      >
        {t(platform)}
      </Typography>
    </Box>
  );
};

export default CompetitorPlatformLabel;
